// ffmpeg -i mihai.mov -an -vcodec h264 -acodec mp2 mihai.mp4
// ffmpeg -i mihai.mp4 -vf "select=eq(n\,0)" -q:v 3 mihai.jpg
// ffmpeg -i stage.mov -an -filter:v "crop=iw:ih-754:0:754" stage.mp4
import React, { Component } from "react";

import Menu from "./menu";

import LogoSVG from "./images/whereby/logo.svg";
import mihaiJPG from "./images/whereby/mihai.jpg";
import mihaiMP4 from "./images/whereby/mihai.mp4";
import productPNG from "./images/whereby/product.png";
import pandemicPNG from "./images/whereby/pandemic.png";
import meetingsMP4 from "./images/whereby/meetings.mp4";
import meetingsJPG from "./images/whereby/meetings.jpg";
import stageMP4 from "./images/whereby/stage.mp4";
import stageJPG from "./images/whereby/stage.jpg";
import stageBackgroundJPG from "./images/whereby/stage_background.jpg";
import reactionsMP4 from "./images/whereby/reactions.mp4";
import reactionsJPG from "./images/whereby/reactions.jpg";
import pipMP4 from "./images/whereby/pip.mp4";
import pipJPG from "./images/whereby/pip.jpg";
import pipBackgroundJPG from "./images/whereby/pip_background.jpg";
import groupsJPG from "./images/whereby/groups.jpg";
import tweetPNG from "./images/whereby/tweet.png";

import "./css/whereby.css";

function CamIcon() {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <rect height="14" rx="3.5" stroke="currentColor" strokeWidth="2" width="16" x="1" y="5" />
      <path
        d="m22.4188 5.12946-5.4188 3.87054v6l5.4188 3.8705c.6618.4728 1.5812-.0003 1.5812-.8137v-12.11361c0-.81337-.9194-1.2865-1.5812-.81373z"
        fill="currentColor"
      />
    </svg>
  );
}

function MicIcon() {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m8 13c0 1.1046.89543 2 2 2h4c1.1046 0 2-.8954 2-2v-8c0-2.20914-1.7909-4-4-4-2.20914 0-4 1.79086-4 4z"
        fill="currentColor"
      />
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="m5 10.5v3.5c0 2.2091 1.79086 4 4 4h6c2.2091 0 4-1.7909 4-4v-3.5" />
        <path d="m12 18v4" />
      </g>
    </svg>
  );
}

function SpeakerIcon() {
  return (
    <svg fill="none" height="25" viewBox="0 0 24 25" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="m16.2578 4.91917c.282-.47484.8956-.63114 1.3704-.3491 1.3454.79912 2.4566 1.95511 3.2231 3.34427.7663 1.38892 1.1618 2.96296 1.1484 4.55986-.0134 1.597-.4353 3.1637-1.225 4.5387-.7898 1.3753-1.9205 2.5111-3.2795 3.2857-.4798.2735-1.0905.1063-1.364-.3735-.2735-.4799-.1062-1.0905.3736-1.364 1.0424-.5942 1.9192-1.471 2.5356-2.5442.6166-1.0735.9488-2.3024.9593-3.5595.0106-1.257-.301-2.49199-.8995-3.57686-.5985-1.08463-1.4607-1.97758-2.4933-2.59092-.4749-.28204-.6312-.89561-.3491-1.37045zm-2.6522 4.06346c.247-.49398.8476-.6942 1.3416-.44721 1.4334.71669 2.5343 1.95428 2.5528 3.88488.0187 1.9548-1.1482 3.2017-2.5528 3.904-.494.247-1.0946.0467-1.3416-.4472-.247-.494-.0468-1.0947.4472-1.3417.9428-.4714 1.4565-1.1257 1.4472-2.096-.0096-1.0029-.5107-1.6469-1.4472-2.1151-.494-.247-.6942-.84769-.4472-1.34167zm-1.6056-2.55279c0-.36027-.1938-.69269-.5073-.8702-.3135-.1775-.6983-.17265-1.0072.01271l-4.76248 2.85749h-3.72302c-.55228 0-1 .44772-1 1v5.99996c0 .5523.44772 1 1 1h3.72301l4.76249 2.8575c.3089.1854.6937.1902 1.0072.0127s.5073-.5099.5073-.8702z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

function ChevronIcon() {
  return (
    <svg fill="none" height="25" viewBox="0 0 24 25" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="m5.29289 9.22282c.39053-.39052 1.02369-.39052 1.41422 0l5.29289 5.29288 5.2929-5.29288c.3905-.39052 1.0237-.39052 1.4142 0 .3905.39053.3905 1.02368 0 1.41418l-6 6c-.3905.3906-1.0237.3906-1.4142 0l-6.00001-6c-.39052-.3905-.39052-1.02365 0-1.41418z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

class Whereby extends Component {
  render() {
    return (
      <div className="whereby-page">
        <Menu type="projects" />
        <div className="intro section-wrapper">
          <div className="intro-background" />
          <div className="section">
            <div className="content">
              <img src={LogoSVG} className="logo" alt="Whereby" />
              <div className="precall">
                <div className="video-wrapper">
                  <video autoPlay loop muted playsInline preload="auto" poster={mihaiJPG}>
                    <source src={mihaiMP4} type="video/mp4" />
                    Your browser doesn't support HTML5 video tag.
                  </video>
                  <div className="controls">
                    <div className="cam btn">
                      <CamIcon />
                    </div>
                    <div className="mic btn">
                      <MicIcon />
                      <div className="level1" />
                      <div className="level2" />
                    </div>
                  </div>
                </div>
                <div className="devices">
                  <div className="row">
                    <CamIcon />
                    <div className="label">FaceTime HD Camera</div>
                    <ChevronIcon />
                  </div>
                  <div className="row">
                    <MicIcon />
                    <div className="label">Macbook Pro Microphone</div>
                    <ChevronIcon />
                  </div>
                  <div className="row">
                    <SpeakerIcon />
                    <div className="label">Macbook Pro Speakers</div>
                    <ChevronIcon />
                  </div>
                  <div className="join">Join call</div>
                </div>
              </div>
            </div>
          </div>
          <div className="rocks" />
          <div className="credits">
            <p>Illustrations by Icinori for Whereby</p>
          </div>
        </div>
        <div className="section-wrapper">
          <div className="section context">
            <div className="column">
              <h1>Where better meetings happen</h1>
              <h2>Opportunity</h2>
              <p>
                In 2019, web based video conferencing was not as prevalent as it is today but it was obviously the
                future. I joined Whereby (formerly appear.in) through the acquisition of <a href="/swipe">Swipe</a>,
                seizing the opportunity to continue advancing web-based communication and storytelling tools.
              </p>
              <h2>Introduction</h2>
              <p>
                After joining, significant internal changes were already underway: a forced rebranding post a legal
                loss, strategic shifts due to acquisition, and high staff turnover. The aging Angular 1 codebase with no
                current stewards, was slated for a React rebuild and a complete product redesign. This was fertile
                ground for me to have a big impact on the direction of the product.
              </p>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Transforming rooms</h2>
              <p className="caption">Role: led early product redesign, implemented and maintained the layout engine</p>
              <p>
                The main design goal of the rebuild was to{" "}
                <mark>create a responsive room layout capable of scaling to hundreds of participants</mark>. Through
                internal prototypes and discussions, I helped establish a vision for a layout engine that preserved what
                made the product special with a lot of added flexibility.
              </p>
              <p>
                <mark>The concept was to provide digital spaces that transform to meet your needs</mark>. The layout
                prioritize screen space based on what was most important in a meeting context—whether it be a 1:1, a
                squad or townhall meeting. It included a rule-based system that dynamically adjusts layouts, ensuring
                seamless transitions as meetings evolved.
              </p>
              <p>
                Recognizing room layout and mechanics as fundamental to the product, I took ownership of its
                implementation and maintenance.
              </p>
            </div>
            <div className="image-wrapper">
              <img src={productPNG} alt="whereby product screenshots" />
            </div>
            <div className="column">
              <p className="caption">
                This was the state of the product mid 2021. Visual design credits to{" "}
                <a href="https://dribbble.com/JordanAmblin" target="_blank" rel="noopener noreferrer">
                  Jordan Amblin
                </a>{" "}
                and the team at{" "}
                <a href="https://heydays.no/projects/whereby" target="_blank" rel="noopener noreferrer">
                  Heydays
                </a>
                .
              </p>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Directing attention</h2>
              <p className="caption">Role: concept, early design, contributed to implementation</p>
              <p>
                <mark>Most video meeting software mimics small groups around a conference table</mark>, but scaling up
                digitally doesn't mirror real-life practices.
              </p>
              <p>
                I suggested using physical meeting layouts as inspiration, employing a stage to distinguish presenters
                from the audience.{" "}
                <mark>
                  By establishing a visual hierarachy and positioning attendees in smaller tiles below the stage, we
                  aimed to alleviate the pressure of constant visibility
                </mark>
                . Placing everyone with active cameras in the front row fostered a supportive atmosphere for presenters.
                This adjustment led to a significant rise in video-on participation and improved large meeting dynamics.
              </p>
            </div>
            <div className="image-wrapper stage">
              <video autoPlay loop muted playsInline preload="auto" poster={stageJPG}>
                <source src={stageMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
              <img src={stageBackgroundJPG} alt="screenshots of whereby product in use" />
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Solving the big meeting participation problem</h2>
              <p className="caption">Role: concept, early design, implementation</p>
              <p>
                <mark>Big meetings have a big participation problem</mark>. Isolated chat interfaces are a distraction
                at best.
              </p>
              <p>
                Drawing from my positive experience, I proposed that larger townhall meetings could adopt a{" "}
                <a href="https://www.youtube.com/watch?v=FPCWSL52uVU" target="_blank" rel="noopener noreferrer">
                  Turntable.fm
                </a>{" "}
                room-like atmosphere.{" "}
                <mark>
                  By integrating inline chat and quick emoji reactions over the video grid we encouraged active audience
                  participation without interruptions
                </mark>
                . Connecting the reaction to the person that sent it is done through playful tile bounce animations that
                animate into view even if the tile is below the fold. We witnessed firsthand how this feature
                transformed our culture, bringing the room to life in a memorable way.
              </p>
            </div>
            <div className="feature-image reactions">
              <video autoPlay loop muted playsInline preload="auto" poster={reactionsJPG}>
                <source src={reactionsMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>
                Breakout <del>Rooms</del> Groups
              </h2>
              <p className="caption">Role: concept, early design</p>
              <p>
                Another effective method to solve the big meeting participation problem is to{" "}
                <mark>temporarily turn a big meeting into many small meetings</mark>. Existing solutions were
                universally hated, causing confusion as participants were abruptly moved between meetings without clear
                visual cues.
              </p>
              <p>
                The proposed solution was to{" "}
                <mark>leverage our adaptable room layouts to maintain continuity within the same meeting</mark>. It
                empowered users to freely move in and out of groups, enhancing agency and ensuring a seamless
                experience. As it's often still desirable to assign people to as specific group we{" "}
                <mark>leveraged presence as indirect communication</mark> - holding space for where people needed to be
                instead of forcing them to go there.
              </p>
            </div>
            <div className="feature-image groups">
              <img src={groupsJPG} alt="screenshots of whereby product in use" />
            </div>
            <div className="column">
              <p className="caption">
                Visual design credits to{" "}
                <a href="https://dribbble.com/JordanAmblin" target="_blank" rel="noopener noreferrer">
                  Jordan Amblin
                </a>
                .
              </p>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider">
          <div className="section">
            <div className="column">
              <h2>Picture-in-Picture</h2>
              <p className="caption">Role: concept, design, implementation</p>
              <p>
                During a company hackathon, I proposed using the{" "}
                <a
                  href="https://developer.mozilla.org/en-US/docs/Web/API/Picture-in-Picture_API"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Picture-in-Picture browser API
                </a>{" "}
                to <mark>solve the problem of context loss during screen sharing</mark>.
              </p>
              <p>
                Despite initial raised concerns about computational overhead of the "hack" due to the need to composite
                multiple video streams into one, I proceeded with the idea and found no measurable performance loss in
                practice.
              </p>
            </div>
            <div className="image-wrapper pip">
              <video autoPlay loop muted playsInline preload="auto" poster={pipJPG}>
                <source src={pipMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
              <img src={pipBackgroundJPG} alt="screenshots of whereby product in use" />
            </div>
            <div className="column">
              <p>
                I later ported reactions into the composite video exposing even more context from the room and it{" "}
                <mark>quickly became one of the most used and beloved features in the product</mark>.
              </p>
              <div className="feature-image tweet">
                <a
                  href="https://x.com/sjoerdhandgraaf/status/1391834586720706562"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={tweetPNG} alt="tweet from @sjoerdhandgraaf listing favorite features" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="section-wrapper has-divider conclusion">
          <div className="section">
            <div className="column">
              <h2>Looking ahead</h2>
              <p>
                We launched a solidly rebuilt product that{" "}
                <a href="https://x.com/dhh/status/1243288962975719426" target="_blank" rel="noopener noreferrer">
                  really stood out
                </a>{" "}
                in a market dominated by enterprise tools just as Covid thrust the video conferencing industry into the
                spotlight. With over 450% growth in the first two months of 2020, we suddenly found ourselves on a{" "}
                <a href="https://whereby.com/blog/announcing-our-series-a/" target="_blank" rel="noopener noreferrer">
                  very different trajectory
                </a>
                .
              </p>
              <p>
                Truly a role I thrived in and I'm still very proud of the work and the difference we made in helping
                countless people stay in touch through the lockdowns.
              </p>
            </div>
            <div className="image-wrapper collage">
              <video autoPlay loop muted playsInline preload="auto" poster={meetingsJPG}>
                <source src={meetingsMP4} type="video/mp4" />
                Your browser doesn't support HTML5 video tag.
              </video>
              <img src={pandemicPNG} alt="screenshots of whereby product in use" />
            </div>
            <div className="column">
              <p>
                <a href="#top" className="to-top">
                  Back to top
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Whereby;



// WEBPACK FOOTER //
// ./src/whereby.js